//gerenciar cores, fontes, etc

export const theme = {
    colors: {
      light: '#fbfafa',
      dark: '#fcd3d3',
      text: '#333333',
    },
    fonts: {
      primary: 'Roboto, sans-serif',
    },
  };
  
  